<template>
  <div class="continer" v-if="!isError">
    <div class="top" @click="goBack()">
      <img src="@/assets/images/daily_task/close.png" alt="" srcset="" />
    </div>
    <van-pull-refresh
      v-model="isLoading"
      success-text="刷新成功"
      @refresh="onRefresh"
    >
      <div class="header">
        <div class="detail">
          <div class="left">
            <img :src="pageData.icon" alt="" />
          </div>
          <div class="right">
            <div class="title">{{ pageData.adname }}</div>
            <div class="block">
              <span>活动时间：</span>
              <span>{{ startTime }}-{{ endTime }}</span>
            </div>
            <div class="block">
              <span>活动规则：</span>
              <span v-html="pageData.rule"></span>
            </div>
            <!-- <div class="rule">
            同一个手机设备只能注册一个账号，否则无法领奖。如有刷号，一律封号，不予结算。
          </div> -->
          </div>
        </div>
      </div>
      <div class="main">
        <div class="tab">
          <div
            class="tab-item"
            :class="[listType == 'today' ? 'activate' : '']"
            @click="switchTab('today')"
          >
            今日榜单
          </div>
          <div
            class="tab-item"
            :class="[listType == 'yesterday' ? 'activate' : '']"
            @click="switchTab('yesterday')"
          >
            昨日榜单
          </div>
          <div
            class="tab-item"
            :class="[listType == 'more' ? 'activate' : '']"
            @click="switchTab('more')"
          >
            {{ tabMoreTxt
            }}<img src="@/assets/images/daily_task/down_arrow.png" />
          </div>
        </div>
        <div class="card">
          <div class="left">
            <p>我的游戏账号</p>
            <p>{{ pageData.game_data.gid || '--' }}</p>
          </div>
          <div class="right">
            <p>当日累计</p>
            <p>
              {{ pageData.game_data.gid ? pageData.game_data.volume : '--' }}
            </p>
          </div>
        </div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in pageData.tasks"
            :key="index"
          >
            <div class="left">
              <div class="index">{{ index + 1 }}</div>
              <div class="detail">
                <p>+{{ item.money }}元</p>
                <p>{{ item.title }}</p>
              </div>
            </div>
            <div class="right">
              <button
                :class="[
                  item.status == 1 ? 'receive' : '',
                  item.status == 2 ? 'received' : '',
                  item.status == 3 ? 'verify' : '',
                ]"
                @click="receiveAward(item)"
              >
                {{
                  item.status == 1
                    ? '待领取'
                    : item.status == 2
                    ? '已领取'
                    : item.status == 3
                    ? '待审核'
                    : '点击领取'
                }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </van-pull-refresh>
    <div class="footer">
      <button @click="goBack()">去试玩</button>
    </div>

    <!-- 日期选择弹窗 -->
    <van-popup
      v-model="datetimeShow"
      round
      position="bottom"
      @click-overlay="onCancel"
    >
      <van-picker
        title="榜单日期"
        show-toolbar
        :columns="timeInterval"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
  <div v-else class="empty">
    <van-empty image="error" description="出现了一点问题~" />
  </div>
</template>

<script>
import Vue from 'vue'
import { Picker, Popup, Toast, Empty, PullRefresh } from 'vant'

Vue.use(Picker)
  .use(Popup)
  .use(Toast)
  .use(Empty)
  .use(PullRefresh)
export default {
  data() {
    return {
      listType: 'today',
      beforeListType: 'today',
      datetimeShow: false,
      startTime: '',
      endTime: '',
      tabMoreTxt: '更多榜单',
      pageData: null,
      cachePageData: new Map(),
      // 参数
      appId: '',
      userId: '',
      adId: '',
      // 记录错误
      isError: false,
      // 下拉刷新
      isLoading: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    // 时间区间
    timeInterval() {
      return this.getDaysInRange(this.startTime, this.endTime)
    },
    // 昨日
    getYesterday() {
      const today = new Date()
      today.setDate(today.getDate() - 1) // 将日期减去一天
      const year = today.getFullYear() // 获取年份
      const month = String(today.getMonth() + 1).padStart(2, '0') // 获取月份（注意：月份从0开始，所以加1，并用padStart确保两位数）
      const day = String(today.getDate()).padStart(2, '0') // 获取日期，并用padStart确保两位数
      return `${year}-${month}-${day}` // 格式化为 YYYY-MM-DD
    },
    // 当前选择时间
    currentDate() {
      const today = new Date() // 获取今天的日期
      if (this.listType == 'today') {
        const year = today.getFullYear() // 获取年份
        const month = String(today.getMonth() + 1).padStart(2, '0') // 获取月份（注意：月份从0开始，所以加1，并用padStart确保两位数）
        const day = String(today.getDate()).padStart(2, '0') // 获取日期，并用padStart确保两位数
        return `${year}-${month}-${day}` // 格式化为 YYYY-MM-DD
      } else if (this.listType == 'yesterday') {
        today.setDate(today.getDate() - 1) // 将日期减去一天
        const year = today.getFullYear() // 获取年份
        const month = String(today.getMonth() + 1).padStart(2, '0') // 获取月份（注意：月份从0开始，所以加1，并用padStart确保两位数）
        const day = String(today.getDate()).padStart(2, '0') // 获取日期，并用padStart确保两位数
        return `${year}-${month}-${day}` // 格式化为 YYYY-MM-DD
      } else {
        const year = today.getFullYear() // 获取年份
        return (
          year + '-' + this.tabMoreTxt.replace(/月/g, '-').replace(/日/g, '')
        )
      }
    },
  },
  methods: {
    init() {
      // 初始化参数
      this.appId = this.$route.query.app_id
      this.userId = this.$route.query.user_id
      this.adId = this.$route.query.ad_id
      // 获取数据
      this.getDailyTask()
    },
    getCookie: function(name) {
      let strcookie = document.cookie //获取cookie字符串
      let arrcookie = strcookie.split('; ') //分割
      //遍历匹配
      for (const element of arrcookie) {
        let arr = element.split('=')
        if (arr[0] == name) {
          return arr[1]
        }
      }
      return ''
    },
    callClienFunc: function(fname, fval) {
      if (window.hasOwnProperty('injectedObject')) {
        window.injectedObject.setJsContent(fname, fval)
      } else {
        fval = fval ? fval : {}
        let params = { method: fname, params: fval }
        params = JSON.stringify(params)
        window.Android.postMessage(params)
      }
    },
    goBack() {
      this.callClienFunc('closeWebview', '')
    },
    getDailyTask(reset = false) {
      const params = {
        app_id: this.appId,
        userid: this.userId,
        ad_id: this.adId,
        date: this.currentDate,
      }

      console.log(params)

      return new Promise((resolve, reject) => {
        // 读取缓存
        if (!reset && this.cachePageData.has(params.date)) {
          console.log('有缓存')

          const cacheRes = this.cachePageData.get(params.date)
          this.pageData = cacheRes
          this.startTime = cacheRes.begin_time
          this.endTime = cacheRes.end_time
          return resolve()
        }
        console.log('无缓存')
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        })
        this.$http
          .get('https://adv.ahaozhuan.com/api/cpl/get_daily_task', {
            params,
          })
          .then((res) => {
            console.log(res)
            if (res.code != 1) {
              this.isError = true
              this.updateListType(this.beforeListType)
              return reject()
            }
            this.pageData = res.data
            this.startTime = res.data.begin_time
            this.endTime = res.data.end_time
            // 缓存数据
            this.cachePageData.set(params.date, res.data)
            this.isError = false
            resolve()
          })
          .catch((err) => {
            console.log(err)
            this.isError = true
            this.updateListType(this.beforeListType)
            reject()
          })
          .finally(() => {
            Toast.clear()
          })
      })
    },
    switchTab(type) {
      if (type == 'more') {
        // 记录上一次类型
        this.beforeListType = this.listType
        this.listType = type
        this.datetimeShow = true
        return
      } else if (type == 'yesterday') {
        // 比对时间
        const res = this.comparatorTime(this.getYesterday, this.startTime)
        if (!res) {
          return
        }
        // 记录上一次类型
        this.beforeListType = this.listType
        this.listType = type
        // this.tabMoreTxt = '更多榜单'
      } else {
        // 记录上一次类型
        this.beforeListType = this.listType
        this.listType = type
        // this.tabMoreTxt = '更多榜单'
      }
      // 获取数据
      this.getDailyTask()
    },
    updateListType(newType) {
      this.beforeListType = this.listType
      this.listType = newType
    },
    async onConfirm(value) {
      try {
        this.tabMoreTxt = value
        await this.getDailyTask()
        this.datetimeShow = false
      } catch (error) {
        console.log(error)
        this.tabMoreTxt = '更多榜单'
      }
    },
    onCancel() {
      // if (this.tabMoreTxt == '更多榜单') {
      //   this.updateListType(this.beforeListType)
      // }
      this.updateListType(this.beforeListType)

      this.datetimeShow = false
    },
    // 点击按钮
    receiveAward(item) {
      if (item.status == 2 || item.status == 3) {
        return
      }
      if (item.status != 1) {
        Toast({
          message: '未达到领取要求',
          position: 'bottom',
        })
        return
      }
      const params = {
        app_id: this.appId,
        userid: this.userId,
        ad_id: this.adId,
        task_id: item.id,
      }
      let msg = '成功'
      this.$http
        .post('https://adv.ahaozhuan.com/api/cpl/complete_daily_task', params)
        .then((res) => {
          if (res.code != 1) {
            msg = res.message
          }
          // 修改状态
          item.status = 2
          // 清除缓存
          this.cachePageData.delete(this.currentDate)
        })
        .catch((err) => {
          console.log(err)
          msg = '领取失败'
        })
        .finally(() => {
          Toast({
            message: msg,
            position: 'bottom',
          })
        })
    },
    async onRefresh() {
      await this.getDailyTask(true)
      this.isLoading = false
    },
    // 获取时间选择
    getDaysInRange(startTime, endTime) {
      // 将字符串日期转换为 Date 对象
      const startDate = new Date(startTime.replace(/\./g, '-')) // 替换为 "-" 符号
      const endDate = new Date(endTime.replace(/\./g, '-')) // 替换为 "-" 符号

      const days = []
      let currentDate = startDate

      // 循环直到当前日期大于结束日期
      while (currentDate <= endDate) {
        // 获取月份和日期，并格式化为 "MM月DD日"
        const month = String(currentDate.getMonth() + 1).padStart(2, '0') // 月份从 0 开始，所以加 1
        const day = String(currentDate.getDate()).padStart(2, '0') // 日期

        const formattedDate = `${month}月${day}日`
        days.push(formattedDate)

        // 增加一天
        currentDate.setDate(currentDate.getDate() + 1)
      }

      return days
    },
    // 比较时间
    comparatorTime(currentTiem, startTime) {
      // 将时间字符串转换为 Date 对象
      const currentDate = new Date(currentTiem.replace(/\./g, '-')) // 将 . 替换为 -
      const startDate = new Date(startTime.replace(/\./g, '-'))
      // 比较两个日期
      if (currentDate >= startDate) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style lang="less" scoped>
.continer {
  max-width: inherit;
  font-family: PingFangSC-Medium;
}

.top {
  position: sticky;
  top: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  height: 0.44rem;
  padding: 0 0.15rem;
  padding-top: 0.3rem;
  background: #ffffff;
  box-shadow: 0 0.02rem 0.06rem 0 rgba(0, 0, 0, 0.03);

  img {
    width: 0.14rem;
  }
}

.header {
  padding: 0.09rem;
  background: #f9f9f9;

  .detail {
    display: flex;
    padding: 0.16rem;
    background: #ffffff;
    border-radius: 0.06rem;
    min-height: 1.6rem;
    box-shadow: 0 0.04rem 0.06rem 0 rgba(0, 0, 0, 0.03);

    .left {
      min-width: 0.52rem;
      margin-right: 0.12rem;

      img {
        width: 0.52rem;
        border-radius: 0.08rem;
      }
    }

    .right {
      .title {
        font-size: 0.16rem;
        color: #333333;
        letter-spacing: 0;
        line-height: 0.18rem;
        font-weight: bold;
        margin-bottom: 0.04rem;
      }

      .block {
        font-size: 0.12rem;
        margin: 0.02rem 0;
        text-align: justify;
        line-height: 0.18rem;

        span:first-child {
          color: #999999;
        }

        span:last-child {
          color: #151515;
        }
      }

      .rule {
        color: red;
      }
    }
  }
}

.main {
  padding-bottom: 0.44rem;

  .tab {
    display: flex;
    // justify-content: space-between;
    // align-items: center;
    height: 0.42rem;
    background: #e6e6e6;

    .tab-item {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      font-size: 0.14rem;
      color: #b3b3b3;

      &:first-child {
        border-radius: 0 0.12rem 0 0;
      }

      &:last-child {
        border-radius: 0.12rem 0 0 0;

        img {
          width: 0.12rem;
          margin-left: 0.02rem;
        }
      }
    }

    .activate {
      background: #ffffff;
      border-radius: 0.12rem 0.12rem 0 0;
      color: #333333;
      font-weight: bold;

      &::after {
        position: absolute;
        bottom: 0.02rem;
        content: '';
        display: block;
        width: 0.16rem;
        height: 0.04rem;
        background: #ff7f4b;
        border-radius: 0.02rem;
      }
    }
  }

  .card {
    display: flex;
    justify-content: center;
    height: 0.69rem;
    margin: 0.12rem 0;

    div {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #ffffff;
      background: #ff7f4b;
      width: 1.72rem;
      height: 100%;
      border-radius: 0.06rem;

      p:first-child {
        opacity: 0.7;
        font-size: 0.12rem;
      }

      p:last-child {
        margin-top: 0.04rem;
        font-size: 0.14rem;
      }
    }

    .left {
      transform: translateX(0.01rem);
    }
  }

  .list {
    width: 90%;
    margin: 0 auto;

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.76rem;
      border-bottom: 0.01rem solid #f7f8fa;

      .left {
        display: flex;

        .index {
          width: 0.24rem;
          height: 0.16rem;
          align-self: flex-start;
          background: #ff7f4b;
          border-radius: 0.02rem;
          color: #ffffff;
          text-align: center;
          margin-right: 0.08rem;
          margin-top: 0.06rem;
        }

        .detail {
          max-width: 2.34rem;

          p:first-child {
            font-weight: bold;
            font-size: 0.18rem;
            color: #ff7f4b;
            letter-spacing: 0;
            line-height: 0.26rem;
          }

          p:last-child {
            font-size: 0.12rem;
            color: #333333;
            letter-spacing: 0;
            line-height: 0.16rem;
            margin-top: 0.02rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .right {
        width: 0.72rem;
        height: 0.32rem;
        font-size: 0.12rem;
        color: #ffffff;

        // 立即领取
        button {
          width: 100%;
          height: 100%;
          background: linear-gradient(134deg, #ff6d2c 0%, #ff1231 100%);
          border-radius: 0.16rem;
          border: none;
        }

        // 审核中
        .verify {
          background: #5690ff;
        }

        // 立即领取
        .receive {
          background: #ff7f4b;
        }

        // 已领取
        .received {
          background: #d8d8d8;
        }
      }
    }
  }
}

.footer {
  max-width: inherit;
  position: fixed;
  bottom: 0.08rem;
  left: 50%;
  transform: translateX(-50%);
  width: 94%;
  height: 0.44rem;
  font-size: 0.16rem;
  color: #ffffff;

  button {
    width: 100%;
    height: 100%;
    border: none;
    background-image: linear-gradient(90deg, #9969ca 0%, #5a6eb5 100%);
    border-radius: 0.22rem;
  }
}

.empty {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

::v-deep .van-picker {
  .van-picker__toolbar {
    .van-picker__cancel {
      color: #4a90e2;
    }

    .van-picker__confirm {
      color: #ff7f4b;
    }

    .van-picker__title {
      font-weight: bold;
    }
  }

  .van-picker__columns1 {
    .van-picker-column {
      z-index: 99;
    }

    .van-picker-column__item {
      color: #666666;
    }

    .van-picker-column__item--selected {
      color: #ffffff;
    }

    .van-hairline-unset--top-bottom {
      width: 100%;
      left: 0;
      right: 0;
      color: #ffffff;

      &::after {
        background: #ff7f4b;
      }
    }
  }
}
</style>
